import { Box } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  maxWidth?: number;
  hasEdgeBleed?: boolean;
};

// hasEdgeBleed stretches the carousel past the parent's padding (negative
// margins) for a wider peek/drag area. Opt-in only: it's safe solely where an
// ancestor clips horizontal overflow (e.g. the onboarding PrimaryPaper) —
// anywhere else (dialogs/drawers) it forces a horizontal scrollbar.
export const CarouselContainer = ({
  children,
  maxWidth,
  hasEdgeBleed = false,
}: Props) => (
  <Box
    sx={{
      maxWidth,
      margin: ({ spacing }) =>
        hasEdgeBleed ? `0 -${spacing(6)} 0 -${spacing(6)}` : 0,
      overflow: "hidden",
      py: "0.75rem",
      userSelect: "none",
    }}
  >
    {children}
  </Box>
);
